var map = {
	"./PHZ.png": "./src/assets/health/PHZ.png",
	"./QXZ.png": "./src/assets/health/QXZ.png",
	"./QYZ.png": "./src/assets/health/QYZ.png",
	"./Rectangle 174.png": "./src/assets/health/Rectangle 174.png",
	"./SRZ.png": "./src/assets/health/SRZ.png",
	"./TSZ.png": "./src/assets/health/TSZ.png",
	"./XYZ.png": "./src/assets/health/XYZ.png",
	"./YAX.png": "./src/assets/health/YAX.png",
	"./YIX.png": "./src/assets/health/YIX.png",
	"./jieguo.png": "./src/assets/health/jieguo.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/health sync recursive ^\\.\\/.*\\.png$";